import { openModal } from '@core/components/ModalStack';
import { BlockBaseConfigProps } from './BlockBaseConfig';

export async function openBlockSettingsOverlay<P extends any>(props: BlockBaseConfigProps<P>) {
  const { BlockBaseConfig } = await import('./BlockBaseConfig');

  openModal(BlockBaseConfig, props as any);
}
